import React from "react";
const AccordionSectionFooter = ({
  children,
  dataTest
}) => /*#__PURE__*/React.createElement("div", {
  className: "p-600 bg-white-normal shadow-level2 sticky bottom-0 flex",
  "data-test": dataTest && `${dataTest}Footer`
}, children);
export default AccordionSectionFooter;